import { fetcher } from '@commenda/utils';
import {
  IIndirectTaxStartRegistrationRequestParams,
  IIndirectTaxStartRegistrationRequestResponse,
} from './types';

/** Starts a request for a registration in a jurisdiction, or returns the one already open there. */
export async function startIndirectTaxRegistrationRequest(
  body: IIndirectTaxStartRegistrationRequestParams
): Promise<{
  success: boolean;
  data?: IIndirectTaxStartRegistrationRequestResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/registrations-v2/requests',
      { method: 'POST', body },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      return {
        success: false,
        error: errorData?.message || 'Failed to start the registration',
      };
    }

    const data: IIndirectTaxStartRegistrationRequestResponse =
      await response.json();
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to start the registration',
    };
  }
}
